<style lang="less" scoped>
@import "./index.less";
</style>

<template>
  <div class="dev-center">
    <div class="dev-center-switch">
        <template v-for="item in settingItem">
          <van-cell :title="item.item">
            <van-switch :value="item.value"  size="24px" @change="(value)=>boolChange(value,item.key)" />
          </van-cell>
        </template>
    </div>
  </div>
</template>

<script>
import Notification from './index.js'
export default {
  ...Notification
}
</script>
